// extracted by mini-css-extract-plugin
export default {"font-list":"FontList_font-list__yMkMB","loading-wrapper":"FontList_loading-wrapper__rcgPE"};